import React from "react";
import { renderToString } from "react-dom/server";
import PropTypes from "prop-types";
import cn from "classnames";
import { Link } from "react-router";

const HOW_IT_WORKS_STEPS = [
  {
    icon: "fa-pencil-square-o",
    title: "Describe what you need",
    description: renderToString(
      <>
        Pick from 33 design categories,
        <br className="show-for-xlarge" /> share your vision and needs,
        <br className="show-for-xlarge" /> and decide your budget.
      </>
    ),
  },
  {
    icon: "fa-clone",
    title: "Creatives submit designs",
    description: renderToString(
      <>
        Collaborate with talented designers,
        <br className="show-for-xlarge" /> provide feedback, rate their designs,
        <br className="show-for-xlarge" /> and see your vision come to life.
      </>
    ),
  },
  {
    icon: "fa-heart-o",
    title: "Choose your favorite",
    description: renderToString(
      <>
        Finalize your favorite design with the
        <br className="show-for-xlarge" /> winner. Get ready-to-use files for
        print
        <br className="show-for-xlarge" /> and web, and full copyright
        ownership.
      </>
    ),
  },
];

const How4 = ({ className, title, steps, cta = {}, extra }) => {
  return (
    <section className={cn("block block-how-4 text-center", className)}>
      <div className="row columns">
        <div className="block-header">
          <h2>{title || "Easy process, brilliant results"}</h2>
        </div>
      </div>
      <div className="row small-up-1 medium-up-3">
        {(steps || HOW_IT_WORKS_STEPS).map((step, i) => (
          <div className="column step" key={i}>
            <h3>
              <i className={`fa ${step.icon}`} /> {step.title}
            </h3>
            <p dangerouslySetInnerHTML={{ __html: step.description }} />
          </div>
        ))}
      </div>
      <Link to={cta.url || "/start-a-project/"} className="btn btn-tertiary">
        {cta.label || "Get started"}
      </Link>
      {extra ? (
        <p dangerouslySetInnerHTML={{ __html: extra }} />
      ) : (
        <p>
          Not into crowds?
          <br /> Pick a designer and{" "}
          <Link to="/1to1-projects/">work 1-on-1</Link>.
        </p>
      )}
    </section>
  );
};

How4.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  steps: PropTypes.array,
  cta: PropTypes.object,
  extra: PropTypes.string,
};

export default How4;
